var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDydxChain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4254 6.63647L8 47.3603H16.7272L45.3002 6.63647H36.4254Z",
    fill: "#8F8F95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6361 6.63647L25.9997 18.6364L21.6361 25.1819L8.72705 6.63647H17.6361Z",
    fill: "#8F8F95"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2727 47.3636L28 34.0909L32.3636 27.7273L45.9999 47.3636H37.2727Z",
    fill: "#5C5C62"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDydxChain);
export default __webpack_public_path__ + "static/media/DYDXChain.283dd2c96ef961af11b603853bab5c7a.svg";
export { ForwardRef as ReactComponent };